import { useState, useEffect } from "react";
import {
  FaEnvelope, FaRegClock,
  FaFacebookF, FaTwitter, FaPinterestP, FaInstagram,
  FaBars, FaXmark, FaPlus, FaPhone
} from "react-icons/fa6";
import "../../styles/Navbar.css";

const links = [
  { href: "#home", label: "Home", hasSub: true },
  { href: "#about", label: "About", hasSub: false },
  { href: "#services", label: "Service", hasSub: true },
  { href: "#contact", label: "Contact", hasSub: false },
  { href: "#pricing", label: "Packages", hasSub: true },
  { href: "#testimonials", label: "Our Clients", hasSub: true },

];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
      {/* --- TOP BAR (Hidden on scroll for cleaner glassy look) --- */}
      {!scrolled && (
        <div className="top-bar">
          <div className="top-bar-inner">
            <div className="top-left-slant">
              <div className="info-item"><FaEnvelope /> <span>info@crownstar.com.au</span></div>
              <div className="info-item"><FaRegClock /> <span>Sun - Fri: 8.00am - 10.00pm</span></div>
            </div>
            <div className="top-right">
              <div className="social-icons">
                {/* <button className="icon-btn"><FaMagnifyingGlass /></button> */}
                <button className="icon-btn"><FaFacebookF /></button>
                <button className="icon-btn"><FaTwitter /></button>
                <button className="icon-btn"><FaPinterestP /></button>
              </div>

            </div>
          </div>
        </div>
      )}

      <nav className="main-nav">
        <div className="container nav-inner">
          <a href="/" className="logo" style={{ minHeight: "60px" }}>
            <img src="/logo.png" alt="Crown-star" className="nav-logo-img" />
          </a>

          <ul className="nav-links">
            {links.map((link) => (
              <li key={link.label}><a href={link.href}>{link.label}</a></li>
            ))}
          </ul>

          <div className="nav-actions">
            <a href="#contact" className="contact-btn">Contact Us</a>
            <button className="mobile-toggle" onClick={() => setOpen(true)}>
              <FaBars />
            </button>
          </div>
        </div>
      </nav>

      <div className={`mobile-sidebar-overlay ${open ? "active" : ""}`} onClick={() => setOpen(false)}>
        <div className="mobile-sidebar" onClick={(e) => e.stopPropagation()}>
          <div className="sidebar-header">
            <div className="logo">
              <img src="/logo.png" alt="Crown-Star" className="sidebar-logo-img" />

            </div>
            <button className="close-btn" onClick={() => setOpen(false)}>
              <FaXmark />
            </button>
          </div>

          <div className="sidebar-menu">
            {links.map((link) => (
              <div key={link.label} className="sidebar-item">
                <a href={link.href}>{link.label}</a>
                {link.hasSub && <FaPlus className="plus-icon" />}
              </div>
            ))}
          </div>

          <div className="sidebar-footer">
            <div className="contact-info">
              <div className="contact-row">
                <div className="icon-circle blue"><FaEnvelope /></div>
                <span>info@crownstar.com.au</span>
              </div>
              <div className="contact-row">
                <div className="icon-circle blue"><FaPhone /></div>
                <span>0492 279 339</span>
              </div>
            </div>
            <div className="sidebar-socials">
              <FaTwitter /> <FaFacebookF /> <FaPinterestP /> <FaInstagram />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}